import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<ControlTimeCard @event={{this.model}}/>",{ moduleName: "bullitttime-event/templates/event/tools/control-time.hbs" })